import translations from './translations.js'
import higherEdTranslations from './higherEdTranslations.js'

let lang = String(navigator.language || navigator.userLanguage).split('-')[0]
const currentTranslations = {...translations}
const supported = ['en', 'es']

if (!supported.includes(lang)) {
	lang = supported[0]
}

function localize(key = '') {
	const string = currentTranslations[lang][key]||key
	const regex = new RegExp('\\\\n', 'g')
	return string.replace(regex, '\n')
}

function localizeWithVars(key, vars = {}) {
	const string = localize(key)
	return Object.keys(vars).reduce((newString, value) => {
		const regex = new RegExp(`{_${value}_}`, 'g')
		return newString.replace(regex, vars[value] || '')
	}, string)
}

function assignHigherEdTranslations() {
	currentTranslations[lang] = Object.assign(currentTranslations[lang], higherEdTranslations[lang])
}

export { localize, localizeWithVars, lang, assignHigherEdTranslations }

export default localize
